import { Handle, Position } from '@xyflow/react'
import { nodeControlClass } from '../../../lib/nodeControlClass.js'
import { selectedBorder } from '../selectedBorder.js'

export function VarGetNode({ data, selected }) {
  const variables = data.variables ?? []
  const varName   = data.varName ?? ''
  const varDef    = variables.find(v => v.name === varName)
  const typeColor = varDef?.type === 'bool' ? '#d06060'
                  : varDef?.type === 'float' ? '#60a0d0'
                  : '#d0a060'

  return (
    <div style={{
      background: selected ? '#2a1e1e' : '#1e1616',
      border: `2px solid ${selected ? selectedBorder('#803030') : '#803030'}`,
      borderRadius: 6,
      padding: '8px 12px',
      minWidth: 150,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 11,
    }}>
      <div style={{ color: '#d09090', fontWeight: 'bold', fontSize: 9, letterSpacing: 1, marginBottom: 5 }}>
        GET VARIABLE
      </div>

      <select
        className={nodeControlClass()}
        value={varName}
        onChange={e => data.onChange?.('varName', e.target.value)}
        onMouseDown={e => e.stopPropagation()}
        style={{
          width: '100%',
          background: '#111',
          color: '#eee',
          border: '1px solid #603030',
          borderRadius: 3,
          padding: '3px 5px',
          fontSize: 11,
          cursor: 'pointer',
        }}
      >
        <option value="">— select variable —</option>
        {variables.map(v => (
          <option key={v.id} value={v.name}>{v.name} ({v.type})</option>
        ))}
      </select>

      {varDef && (
        <div style={{ color: typeColor, fontSize: 9, marginTop: 4 }}>
          type: {varDef.type}
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        id="out"
        style={{ background: typeColor || '#d06060', width: 10, height: 10 }}
      />
    </div>
  )
}
